// extracted by mini-css-extract-plugin
module.exports = {"detail-layout":"myAdsDetail_detail-layout__50sIk","tools-layout":"myAdsDetail_tools-layout__Pe7ef"};